
import { mapState, mapMutations } from "vuex";
import calender from "~/assets/images/insights/calender.svg";
import ReportHeaderDateRangeOptions from "./report-header-date-range-options.vue";
import moment from "moment";
export default {
  props: {
    isVertical: {
      type: Boolean,
      default: false
    },
    selectedTimeRange: {
      type: String,
      default: ""
    },
    selectedStartDate: {
      type: String,
      default: ""
    },
    selectedEndDate: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    DAY_START_TIME: " 00:00",
    DAY_END_TIME: " 23:59:59",
    calender,
    menu: false,
    timeList: [
      { value: "today", label: "Today", range: "day" },
      { value: "yesterday", label: "Yesterday", range: "day" },
      { value: "this-week", label: "This Week", range: "week" },
      { value: "last-week", label: "Last Week", range: "week" },
      { value: "custom", label: "Custom Period", range: "custom" }
    ]
  }),
  components: { ReportHeaderDateRangeOptions },
  computed: {
    ...mapState("report", ["sortOrder"]),
    getLabel() {
      const selectedTimeRange = this.selectedTimeRange || "today";
      return this.timeList.find((el) => el.value == selectedTimeRange)?.label;
    }
  },
  mounted() {
    const selectedTimeRange = this.selectedTimeRange || "today";
    this.dateRangeChange(false, selectedTimeRange);
  },
  methods: {
    ...mapMutations("report", ["SET_DATE_TIME_RANGE", "SET_REPORT_PRODUCTS"]),
    setDateRange({ force, selectedTime, closeMenu, customDateConfig }) {
      this.dateRangeChange(force, selectedTime, customDateConfig);
      this.menu = !closeMenu;
    },
    dateRangeChange(force, selectedTime = "today", customDateConfig) {
      let startDate,
        endDate,
        date = new Date();
      const day = (date.getDay() + 6) % 7;
      const now = moment(new Date()).format("YYYY-MM-DD HH:mm");
      switch (selectedTime) {
        case "today":
          startDate =
            moment(new Date()).format("YYYY-MM-DD") + this.DAY_START_TIME;
          endDate = now;
          break;
        case "yesterday":
          date.setDate(date.getDate() - 1);
          startDate = date.toISOString().substring(0, 10) + this.DAY_START_TIME;
          endDate = date.toISOString().substring(0, 10) + this.DAY_END_TIME;
          break;
        case "this-week":
          date.setDate(date.getDate() - day);
          startDate = date.toISOString().substring(0, 10) + this.DAY_START_TIME;
          endDate = now;
          break;
        case "last-week":
          date.setDate(date.getDate() - day - 1);
          endDate = date.toISOString().substring(0, 10) + this.DAY_END_TIME;
          date.setDate(date.getDate() - 6);
          startDate = date.toISOString().substring(0, 10) + this.DAY_START_TIME;
          break;
        case "custom":
          if (!customDateConfig) {
            return;
          }
          startDate = `${customDateConfig.fromDate} ${customDateConfig.fromTime}`;
          endDate = `${customDateConfig.toDate} ${customDateConfig.toTime}`;
          break;
      }
      const dateRangeSelected = {
        selectedStartDate: startDate,
        selectedEndDate: endDate,
        selectedTimeRange: selectedTime,
        selectedRangeInterval: this.timeList.find(
          (el) => el.value == selectedTime
        )?.range
      };
      this.$emit("date-range-changed", { dateRangeSelected, force });
      this.$emit("fetchReport", dateRangeSelected);
    },
    formattedDate(originalDate) {
      const date = moment(originalDate, "YYYY-MM-DD HH:mm");
      return date.format("DD MMM YYYY");
    }
  }
};
